import { Outlet, Navigate } from "react-router-dom";

import { EProduct } from "../types/misc.enum";

import { useSuspenseEffectiveEntitlementsForUser } from "../hooks/entitlements";

export const ProductRoutes = ({ product }: { product: EProduct }) => {
    const { data: entitlements } = useSuspenseEffectiveEntitlementsForUser();

    return (
        entitlements.products.some(p => p.key === product)
            ? <Outlet />
            : <Navigate to="/" />
    );
};